import { useState } from 'preact/hooks';
import { api } from '../lib/api';
import { useAsync } from '../lib/store';

/** Tag combobox: suggests existing tags to encourage reuse over near-duplicates. */
export function TagInput({ value, onChange, id }: { value: string[]; onChange: (v: string[]) => void; id: string }) {
  const [text, setText] = useState('');
  const { data } = useAsync(() => api.get<{ items: { name: string; count: number }[] }>('/tags'), []);
  const add = (raw: string) => {
    const t = raw.trim().toLowerCase().replace(/\s+/g, ' ');
    if (t && !value.includes(t)) onChange([...value, t]);
    setText('');
  };
  return (
    <div>
      <div class="chips" style={{ marginBottom: value.length ? 'var(--bk-space-2)' : 0 }}>
        {value.map((t) => (
          <button type="button" class="dr-tag" aria-label={`Remove tag ${t}`} onClick={() => onChange(value.filter((x) => x !== t))}>
            {t} ✕
          </button>
        ))}
      </div>
      <input
        id={id}
        class="dr-input"
        list={`${id}-list`}
        placeholder="Add a tag and press Enter"
        value={text}
        onInput={(e) => {
          const v = e.currentTarget.value;
          if (v.endsWith(',')) add(v.slice(0, -1));
          else setText(v);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            add(text);
          } else if (e.key === 'Backspace' && !text && value.length) onChange(value.slice(0, -1));
        }}
        onBlur={() => text && add(text)}
      />
      <datalist id={`${id}-list`}>
        {data?.items
          .filter((t) => !value.includes(t.name))
          .map((t) => (
            <option value={t.name}>{`${t.count}×`}</option>
          ))}
      </datalist>
    </div>
  );
}
